import {
    GET_CONFIG_FORM22,
    GET_COMBO_TIPO_GASTO,
    GET_COMBO_COBERTURA,
    GET_COMBO_MONEDAS,
    GET_GRILLA_HISTORIAL_GASTOS,
    POST_ACTUALIZAR_TIPO_GASTO,
    POST_ANULAR,
    SET_LOADING_GASTOS,
    LIMPIAR_REF,
    GET_MONTOS
    
} from '../types';

export default function modalGastosHonorariosReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM22:
            return { ...state, cfg_form22:action.payload }
        case GET_COMBO_TIPO_GASTO:
            return { ...state, comboTipoGasto:action.payload }
        case GET_COMBO_COBERTURA:
            return { ...state, comboCobertura:action.payload }
        case GET_COMBO_MONEDAS:
            return { ...state, comboMonedas:action.payload }
        case GET_GRILLA_HISTORIAL_GASTOS:
            return { ...state, grillaHistorialGastos:action.payload }
        case POST_ACTUALIZAR_TIPO_GASTO:
            return { ...state, respuestaTipoGastos:action.payload }
        case POST_ANULAR:
            return { ...state, respuestaAnular:action.payload }
        case SET_LOADING_GASTOS:
            return { ...state, loadingGastos:action.payload }
        case LIMPIAR_REF:
            return { ...state, cleanRef:action.payload }  
        case GET_MONTOS:
            return { ...state, montosInformados:action.payload }  
        default:
            return state
    }
}